/**
 * Página de éxito del checkout AR VIP (/exclusive-ar/success).
 * Mercado Pago redirige aquí (back_url del preapproval_plan) tras el pago.
 * Flujo: gracias → Clerk registro → completar perfil → pending-approval → acceso.
 */

import GraciasAr from "@/components/GraciasAr";

export default function ExclusivoArSuccess() {
  // Plan VIP AR ($49.999 / hosteado): siempre embudo Clerk, no Telegram directo.
  return <GraciasAr defaultPlan="vip" />;
}
